import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetCallTypeList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'CallType/GetAllCallTypeList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewCallType = async (CallTypeDet) => {
    //debugger;
    //console.log(JSON.stringify(CallTypeDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `CallType/CreateNewCallType`, 
        JSON.stringify(CallTypeDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateCallType = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `CallType/ActivateDeActivateCallType?CallTypeId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateCallType = async(CallTypeDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'CallType/UpdateCallType', 
        JSON.stringify(CallTypeDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}

export const GetMappedAndUnmappedCaseCategoryList = async(Id) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `CallType/GetMappedAndUnmappedCaseCategoryList?callTypeId=${Id}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const MapCallType_CaseCategory = async(CallTypeCaseCategoryMappingDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'CallType/MapCallType_CaseCategory', 
        JSON.stringify(CallTypeCaseCategoryMappingDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}